import { useEffect, useMemo, useRef } from 'react'
import {
  buildExternalLinksMiniSearchIndex,
  searchExternalLinksMiniSearch,
} from '../local/externalLinksRegistry'

/**
 * Runs the curated external/help links through a MiniSearch (BM25) index and
 * routes results to SupplementarySearchContext under
 * providerId='external-help-minisearch'.
 *
 * This is the only engine behind the help rows — it presents to users and feeds
 * the non-content section of the search-quality report.
 */
function ExternalLinksMiniSearchProvider({ query, options, onResults }) {
  const ms = useMemo(() => buildExternalLinksMiniSearchIndex(), [])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 6
    const hits = searchExternalLinksMiniSearch(ms, query, limit)
    onResultsRef.current({ hits })
  }, [query, ms, options])

  return null
}

export default ExternalLinksMiniSearchProvider
